<template>
  <div>
    <BaseDocumentInput
      v-model="identityDocument"
      :label="$t('ID')"
      :post-action="`${API_URL}/kyc/identity_document`"
      :previous-value="previousIdentityDocument"
      input-ref="identityDocument"
      name="identityDocument"
      class="mb-8"
      @input="uploadIdentityDocument"
    >
      <span class="font-heavy leading-normal">Type de document</span>
      <ul class="leading-normal">
        <li>{{ $t('Passeport') }}</li>
        <li>{{ $t('ID card') }}</li>
      </ul>
    </BaseDocumentInput>
    <BaseDocumentInput
      v-model="extraIdentityDocument"
      :label="$t('Extra ID')"
      :post-action="`${API_URL}/kyc/extra_identity_document`"
      :previous-value="previousExtraIdentityDocument"
      input-ref="extraIdentityDocument"
      name="extraIdentityDocument"
      class="mb-8"
      @input="uploadExtraIdentityDocument"
    >
      <span class="font-heavy leading-normal">Type de document</span>
      <ul class="leading-normal">
        <li>{{ $t('ID card back') }}</li>
      </ul>
    </BaseDocumentInput>
    <BaseDocumentInput
      v-model="residenceDocument"
      :label="$t('Proof of address')"
      :post-action="`${API_URL}/kyc/proof_of_address_document`"
      :previous-value="previousProofOfAddress"
      input-ref="residenceDocument"
      class="mb-8"
      name="residenceDocument"
      @input="uploadProofOfAddress"
    >
      <span class="font-heavy leading-normal">Type de document</span>
      <ul class="leading-normal">
        <li>{{ $t('House expense invoice') }}</li>
        <li>{{ $t('Phone expense invoice') }}</li>
        <li>{{ $t('Tax notice') }}</li>
        <li>{{ $t('Property title') }}</li>
        <li>{{ $t('Rent receipt') }}</li>
        <li>{{ $t('Certificate of home insurance') }}</li>
      </ul>
    </BaseDocumentInput>
  </div>
</template>

<script>
import BaseDocumentInput from '../../components/BaseDocumentInput.vue';
import BaseSection from '../../components/BaseSection.vue';
import kycAttachment from '../../mixins/kycAttachment';

export default {
  name: 'KycAttachmentContent',
  components: {
    BaseDocumentInput,
    BaseSection,
  },
  mixins: [kycAttachment],
};
</script>
